import React from 'react';
import Navbar from '../Components/Layout/Navbar';
import Btn from '../Components/Common/Btn';
import './Home.css'
import { useTranslation } from 'react-i18next';
import EventCard from '../Components/Common/EventCard';

import HeroImg from '../Assets/HeroImg.png'
import SearchBar from '../Components/Layout/Searchbar';
import FeatureCard from '../Components/Common/FeatureCard';
import FIcon1 from '../Assets/Icons/Cart.svg'
import FIcon2 from '../Assets/Icons/Ticket.svg'
import FIcon3 from '../Assets/Icons/Card.svg'
import SecTitle from '../Components/Common/SecTitle';
import ECard1 from '../Assets/CArds/ECard1.png'
import ECard2 from '../Assets/CArds/ECard2.png'
import ECard3 from '../Assets/CArds/ECard3.png'
import ECard4 from '../Assets/CArds/ECard4.png'
import ECard5 from '../Assets/CArds/ECard5.png'
import ECard6 from '../Assets/CArds/ECard6.png'
import CreateImg from '../Assets/Images/CreateImg.png'
import BookForm from '../Components/Layout/BookForm';
import BlogCard from '../Components/Common/BlogCard';
import BCard1 from '../Assets/CArds/BCard1.png'
import BCard2 from '../Assets/CArds/BCard2.png'
import BCard3 from '../Assets/CArds/BCard3.png'
import Footer from '../Components/Layout/Footer';


const Home = () => {
    const { t } = useTranslation();

    return ( 
        <>
            <Navbar />
            
            <section className='Hero'>
                <div className='HeroContent'>
                    <p className='HeroTitle'>{t('hero.title')}</p>
                    <p className='HeroSub'>{t('hero.subtitle')}</p>
                    <Btn BtnText={t('hero.cta')} BtnStyle='WhiteBtn'/>
                </div>

                <img className='HeroImg' src={HeroImg} alt={t('hero.imgAlt')} />

                <SearchBar />
            </section>

            <section className='Features' id='Features'>
            <FeatureCard 
                FCardImg={FIcon1} 
                FCardTitle={t('features.easy.title')} 
                FCardSub={t('features.easy.sub')} 
            />
            <FeatureCard 
                FCardImg={FIcon2} 
                FCardTitle={t('features.instant.title')} 
                FCardSub={t('features.instant.sub')} 
            />
            <FeatureCard 
                FCardImg={FIcon3} 
                FCardTitle={t('features.secure.title')} 
                FCardSub={t('features.secure.sub')} 
            />
            </section>

            <section className='Events'>
                <SecTitle TitleText1={t('SecTitle.TitleText1')} TitleText2={t("SecTitle.TitleText2")} TitleSub={t("SecTitle.TitleSub")} />

                <div className='EventCards'>
                    <EventCard Day={t('events.cairoJazz.day')} Year={t('events.cairoJazz.year')} ECardImg={ECard1} ECardLoc={t('events.cairoJazz.location')} ECardTitle={t('events.cairoJazz.title')} />
                    <EventCard Day={t('events.nileFood.day')} Year={t('events.nileFood.year')} ECardImg={ECard2} ECardLoc={t('events.nileFood.location')} ECardTitle={t('events.nileFood.title')} />
                    <EventCard Day={t('events.pyramidsYoga.day')} Year={t('events.pyramidsYoga.year')} ECardImg={ECard3} ECardLoc={t('events.pyramidsYoga.location')} ECardTitle={t('events.pyramidsYoga.title')} />
                    <EventCard Day={t('events.artWalk.day')} Year={t('events.artWalk.year')} ECardImg={ECard4} ECardLoc={t('events.artWalk.location')} ECardTitle={t('events.artWalk.title')} />
                    <EventCard Day={t('events.filmPremiere.day')} Year={t('events.filmPremiere.year')} ECardImg={ECard5} ECardLoc={t('events.filmPremiere.location')} ECardTitle={t('events.filmPremiere.title')} />
                    <EventCard Day={t('events.karnakShow.day')} Year={t('events.karnakShow.year')} ECardImg={ECard6} ECardLoc={t('events.karnakShow.location')} ECardTitle={t('events.karnakShow.title')} />
                </div>
            </section>

            <section className='Create' id='Create'>
                <img className='CreateImg' src={CreateImg} alt={t("createSection.imgAlt")} />
                <div className='CreateContent'>
                    <p className='CTitle'>{t("createSection.title")}</p>
                    <p className='CSub'>{t("createSection.sub")}</p>
                    <Btn BtnText={t("createSection.btn")} BtnStyle='PinkBtn'/>
                </div>
            </section>

            <section className='Book'>
                <SecTitle TitleText1='Book' TitleText2='Your Tickets' TitleSub='Fill out the form below to reserve your spot at your favorite event'/>

                <BookForm />
            </section>

            <section className='Blog'>
                <SecTitle TitleText1='Blog' TitleText2='Posts' TitleSub='Tips, trends, and ideas to help you discover, plan, and create unforgettable events.'/>

                <div className='BlogCards'>
                    <BlogCard Day={t("blogCards.card1.day")} Year={t("blogCards.card1.year")} BCardImg={BCard1} BCardTitle={t("blogCards.card1.title")} BCardP={t("blogCards.card1.p")} />
                    <BlogCard Day={t("blogCards.card2.day")} Year={t("blogCards.card2.year")} BCardImg={BCard2} BCardTitle={t("blogCards.card2.title")} BCardP={t("blogCards.card2.p")} />
                    <BlogCard Day={t("blogCards.card3.day")} Year={t("blogCards.card3.year")} BCardImg={BCard3} BCardTitle={t("blogCards.card3.title")} BCardP={t("blogCards.card3.p")} />
                </div>

                <Btn BtnText='View More' BtnStyle='PinkBtn'/>
            </section>

            <Footer />
        </>
     );
}
 
export default Home;